export abstract class BaseClass {
    [key: string]: any;
    private timeZoneOffset:number = 60000;
    
    abstract init(data:{}):void;
    abstract getCompareObjectKeys():ObjectProperties[];

    public getInitalDate(dateValue:number|string, includeTime:boolean = false):string{
        if(typeof dateValue === "string"){
            if(includeTime){
                return dateValue
            }else{
                return dateValue.substring(0,10);
            }
            
        }else if(typeof dateValue === "number"){
            return this.getStringDateFromNumber(dateValue);
        }else{
        /*use default date*/return dateValue; //new Date(data.createDate);
        }  
    }

    public getDateFromString(date:string):Date{
        let stringDate:Date = new Date(date);
        return new Date(stringDate.getTime()+(stringDate.getTimezoneOffset()*this.timeZoneOffset));//remove the timzone offset
    }

    public getStringDateFromNumber(value:number, includeTime:boolean = false):string{
        let date:Date = new Date(value); //new Date(tempDate.getTime()+(tempDate.getTimezoneOffset()*this.timeZoneOffset));
        let day = date.getDate();
        let month = date.getMonth()+1
        let year = date.getFullYear();
        let formatDate = "";

        if(day.toString().length===1 && month.toString().length ===1){
            formatDate = year+"-0"+month+"-0"+day
        }else if(month.toString().length ===1){
            formatDate = year+"-0"+month+"-"+day
        }else if(day.toString().length===1){
            formatDate = year+"-"+month+"-0"+day
        }else{
            formatDate = year+"-"+month+"-"+day
        }
        if(includeTime){
            let hour = date.getHours();
            let min = date.getMinutes();
            let sec = date.getSeconds();
            let milSec = date.getMilliseconds();
            formatDate = formatDate + " " + hour + ":" + min + ":" + sec + ":" + milSec ;
        }
        return formatDate;
    }

    public roundUp(number:number, decPlaces:number){
        var numberOfDescimale = Math.pow(10, decPlaces)
        return Math.ceil( (number+Number.EPSILON) * numberOfDescimale) / numberOfDescimale
    }
    public roundNumber(number:number, decPlaces:number){
        var numberOfDescimale = Math.pow(10, decPlaces)
        return Math.round( (number+Number.EPSILON) * numberOfDescimale) / numberOfDescimale
    }

    public formatNumber(numValue:number,wholeNumMask:number,decimalNumMask:number):string{
        let strValue = numValue.toString();
        let valueSplit = strValue.split(".")
        let wholeNumPart:string = valueSplit[0]
        let decimalNumPart:string = "";

        if(wholeNumMask > 0){
            if(wholeNumPart.length !== wholeNumMask){
                let wholeDiff = wholeNumMask - wholeNumPart.length;
                if(wholeDiff > 0){
                    for (let index = 0; index < wholeDiff; index++) {
                        wholeNumPart = "0"+wholeNumPart;
                    }
                }
            }
        }

        if(decimalNumMask>0){
            if(valueSplit.length === 2){
                decimalNumPart = valueSplit[1]
            }
            let decmialDiff = decimalNumMask - decimalNumPart.length
            if(decmialDiff > 0){
                for (let index = 0; index < decmialDiff; index++) {
                    decimalNumPart += "0"
                }
            }else if(decmialDiff < 0){
                decimalNumPart = decimalNumPart.substring(0 ,(decmialDiff*-1)-1)
            }

            return wholeNumPart+"."+decimalNumPart;
        }

        return wholeNumPart;

    }

    public baseFindItems(uniquePropertyKeySet:string[], testObject:any, arrayList:any[]):{index:number,item:any}[]{
        let duplicates:{index:number,item:any}[]=[];

        arrayList.map((aItem,aIndex)=>{
            let isMatch:boolean = true;
            uniquePropertyKeySet.map((keyProp)=>{
                if(aItem[keyProp] !== testObject[keyProp]){
                    isMatch=false;
                }
            })

            if(isMatch){
                duplicates.push({index:aIndex,item:aItem});
            }

        });
        return duplicates;
    };

    public baseValidatePropertyValues(checkProperties:{prop:string,invalidChecks:string[]}[],checkObject:any):{property:string,invalidPasses:string}[]{
        let invalidProperties:{property:string,invalidPasses:string}[]=[];
        checkProperties.map(checkProp=>{
            let invalidPasses:string = this.baseValidatePropertyV(checkProp,checkObject);
            
            if(invalidPasses.length>1){
                invalidProperties.push({property:checkProp.prop,invalidPasses:invalidPasses})
            }
        });

        return invalidProperties;
    };

    public baseValidatePropertyV(checkProperty:{prop:string,invalidChecks:string[]},checkObject:any):string{
        let invalidProperties:string = "";
        let invalidPasses:string = "";

        if( typeof checkObject[checkProperty.prop] === "string"){
            checkProperty.invalidChecks.map(invalidCheck=>{
                if(invalidCheck === "" && checkObject[checkProperty.prop] === ""){
                    invalidPasses += "cannot be empty.;";
                };
            });
        }else if(typeof checkObject[checkProperty.prop] === "number"){
            checkProperty.invalidChecks.map(invalidCheck=>{
                if(invalidCheck === "0" && checkObject[checkProperty.prop] === 0) {
                    invalidPasses += "cannot be zero.;";
                };
            });
        };

        if(invalidPasses.length>1){
            return invalidPasses;
        };

        return invalidProperties;
    };

    public baseSearchArrayObject(array:any, property:string, value:any):{object:any,index:number}|null{
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] === value){
                return {object:array[index],index:index};
            }
        }
        return null
    }

    public baseSearchArrayObjectStringIngnoreCase(array:any, property:string, value:string):{object:any,index:number}|null{
        for (let index = 0; index < array.length; index++) {
            if(array[index][property].toLowerCase() === value.toLowerCase()){
                return {object:array[index],index:index};
            }
        }

        return null
    }

    public baseSearchArrayObjectForHighestValue(array:any, property:string,highestValue:any):{object:any,index:number}|undefined{
        let returnObject:{object:any,index:number}|undefined;
        if(array.length>0 && highestValue === null){
            highestValue = array[0][property];
            returnObject = {object:array[0],index:0};
        }
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] > highestValue){
                highestValue = array[index][property]
                returnObject = {object:array[index],index:index};
            }
        }
        // if(array.length === 0){
        //     let obj = {};
        //     obj[property] = null
        //     return {object:obj,index:-1};
        // };
        return returnObject
    }

    public baseSearchArrayObjectForLowestValue(array:any, property:string,lowestValue:any=null):{object:any,index:number}|undefined{
        let returnObject:{object:any,index:number}|undefined;
        if(array.length>0 && lowestValue === null){
            lowestValue = array[0][property];
            returnObject = {object:array[0],index:0};
        }
        for (let index = 0; index < array.length; index++) {
            if(array[index][property] < lowestValue){
                lowestValue = array[index][property]
                returnObject = {object:array[index],index:index};
            }
        }
        // if(array.length === 0){
        //     let obj = {};
        //     obj[property] = null
        //     return {object:obj,index:-1};
        // };
        return returnObject
    }

    public checkObjectDiffs(baseObject:any, checkObject:any):{key:string,baseValue:any, checkValue:any, dataType:string}[]|null{
        let diffs:{key:string,baseValue:any, checkValue:any, dataType:string}[] = []

        if( baseObject.getCompareObjectKeys() !== undefined && checkObject.getCompareObjectKeys() ){
            let baseObjectKeys:ObjectProperties[] = baseObject.getCompareObjectKeys();
            let checkObjectKeys:ObjectProperties[] = checkObject.getCompareObjectKeys();
            let matchedObjectKeys:ObjectProperties[] = []

            if( baseObjectKeys.length > 0 && checkObjectKeys.length > 0 ){
                baseObjectKeys.forEach((baseItem)=>{
                    checkObjectKeys.forEach((checkItem)=>{
                        if(baseItem.key.toLowerCase() === checkItem.key.toLowerCase()){
                            matchedObjectKeys.push(baseItem);
                        }
                    })
                })
                if(matchedObjectKeys.length === baseObjectKeys.length){
                    //start check
                    matchedObjectKeys.forEach((objKey)=>{
                        let item = this.checkObjectPropertyDiff(baseObject, checkObject, objKey.key);
                        if(item.dataType === "object"){
                            // this.checkObjectDiffs(baseObject[objKey.key],checkObject[objKey.key])
                        }else{
                            diffs.push(item)
                        }
                    })
                }
                return null
            }else{
                return null;
            }
        }
        return null;
    }

    public checkObjectPropertyDiff(baseObject:any, checkObject:any,key:string):{key:string,baseValue:any, checkValue:any, dataType:string}{
        if(typeof baseObject[key] === "string" && typeof checkObject[key] === "string" && baseObject[key] !== checkObject[key]){
            return {key:key, baseValue:baseObject[key], checkValue:checkObject[key], dataType:"string"}
        }

        if(typeof baseObject[key] === "number" && typeof checkObject[key] === "number" && baseObject[key] !== checkObject[key]){
            return {key:key, baseValue:baseObject[key], checkValue:checkObject[key], dataType:"number"}
        }

        if(typeof baseObject[key] === "boolean" && typeof checkObject[key] === "boolean" && baseObject[key] !== checkObject[key]){
            return {key:key, baseValue:baseObject[key], checkValue:checkObject[key], dataType:"boolean"}
        }

        if(typeof baseObject[key] === "object" && typeof checkObject[key] === "object" && baseObject[key] !== checkObject[key]){
            return {key:key, baseValue:baseObject[key], checkValue:checkObject[key], dataType:"object"}
        }

        if(typeof baseObject[key] === "undefined" && typeof checkObject[key] === "undefined" && baseObject[key] !== checkObject[key]){
            return {key:key, baseValue:baseObject[key], checkValue:checkObject[key], dataType:"undefined"}
        }

        return {key:key, baseValue:baseObject[key], checkValue:checkObject[key], dataType:"mismatch"}
    }

}
export class ObjectProperties{
    key:string;

    constructor(key:string){
        this.key = key;
    }
}